import type { Logger } from "@expert/logging";

import type { ChallengeInfo } from "../../../../api/getChallengesForEmployee";

import { findMyTeam } from "./findMyTeam";
import { isDisqualified } from "./isDisqualified";

/**
 * Given an array of challenges, find the first active one:
 * 1. Sort by startDate
 * 2. Find first where ackEnd is not true, not quiz type, not disqualified
 *
 * NOTE: employeeId is passed explicitly instead of reading from userCache
 */
export const findFirstActiveChallenge = (
    logger: Logger,
    challenges: ChallengeInfo[] | null | undefined,
    employeeId: string,
) => {
    return challenges
        ?.sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime())
        .find(
            (c) =>
                (c.announcement === undefined || c.announcement.ackEnd !== true) &&
                c.challengeType !== "quiz" &&
                !isDisqualified(findMyTeam(logger, c.details, employeeId).conditions),
        );
};
